import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import logo from '../assets/closeup-logo.png';
import heroImage from '../assets/ap.png';
import bgImage from '../assets/bg.png';
import pBgImage from '../assets/pbg.png';
import free2love from '../assets/free2love.png';
import { FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp } from 'react-icons/fa';
import html2canvas from 'html2canvas';
import { Link } from 'react-router-dom';
import TermsAndConditions from './TermsAndConditions';
import CookieConsent from './CookieConsent';

const defaultTranslations = {
  en: {
    title: 'Share your heartfelt journey with us',
    subtitle: 'We want to hear your inspiring stories!',
    name: 'Name',
    email: 'Email',
    phone: 'Phone Number',
    story: 'Your Love Story\'s Fate',
    publishWithName: 'Publish with my name',
    publishAnonymously: 'Publish anonymously',
    submit: 'Submit',
    success: 'Story submitted successfully!',
    error: 'Error submitting story',
    selectLanguage: 'Select Language',
    english: 'English',
    storyType: 'Share your story with us',
    loveStory: 'A long story that broke barriers',
    bootStory: 'A short story that remained silent',
    moreStories: 'Dive into more stories like this!'
  },
  si: {
    title: 'ඔයාගෙ කතාව අපි එක්ක බෙදා ගන්න',
    subtitle: 'අපිත් ආසයි ඒ කතාව දැනගන්න',
    name: 'නම',
    email: 'ඊ මේල්',
    phone: 'දුරකථන අංකය',
    story: 'ඔයාගෙ කතාව අපි එක්ක බෙදා ගන්න',
    publishWithName: 'මගේ නමින්ම ප්‍රකාශයට පත් කරමි',
    publishAnonymously: 'නිර්ණාමිකව ප්‍රකාශයට පත් කරමි',
    submit: 'යොමු කරන්න',
    success: 'කතාව සාර්ථකව යොමු කරන ලදී!',
    error: 'කතාව යොමු කිරීමේ දෝෂයකි',
    selectLanguage: 'Select Language',
    sinhala: 'සිංහල',
    storyType: 'ඔයාට හිතෙන විදියට ඔයාගෙ කතාව?',
    loveStory: 'Barriers කඩපු long story එකක්',
    bootStory: 'නිහඬවම තිබුන short story එකක්',
    moreStories: 'තවත් මෙවැනිම කතා කියවන්න'
  },
  ta: {
    title: 'உங்கள் கதையை எங்களுடன் பகிர்ந்து கொள்ளுங்கள்',
    subtitle: 'நாம் உங்கள் மனதை தொடும் கதையை கேட்க ஆவலுடன் இருக்கிறோம்.',
    name: 'பெயர்',
    email: 'மின்னஞ்சல்',
    phone: 'ொலைபேசி இலக்கம்',
    story: 'உங்கள் கதையை எங்களுடன் பகிருங்கள்',
    publishWithName: 'எனது பெயரில் வெளியிடவும்',
    publishAnonymously: 'அநாமதேயமாக வெளியிடவும்',
    submit: 'சமர்ப்பிக்கவும்',
    success: 'கதை வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது!',
    error: 'கதையைச் சமர்ப்பிப்பதில் பிழை',
    selectLanguage: 'Select Language',
    tamil: 'தமிழ்',
    storyType: 'உங்கள் காதல் கதையின் விளைவு',
    loveStory: 'தடைங்களை உடைத்த நீண்ட கதையொன்று',
    bootStory: 'மௌனமாகவே இருந்த ஒரு குறுகிய கதையொன்று',
    moreStories: 'இது போன்ற மேலும் கதைகளைப் படியுங்கள்'
  }
};

const StoryForm = ({ language = 'en', setLanguage, translations = defaultTranslations, isDropdownOpen, setIsDropdownOpen = () => {} }) => {
  const t = translations[language] || defaultTranslations[language];
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    story: '',
    isAnonymous: false,
    storyType: 'love'
  });
  const [mousePosition, setMousePosition] = useState({ x: 50, y: 50 });
  const [showThankYouPopup, setShowThankYouPopup] = useState(false);
  const [submittedStory, setSubmittedStory] = useState(null);
  const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const pageContainerRef = useRef(null);
  const storyCardRef = useRef(null);
  
  const [localIsDropdownOpen, setLocalIsDropdownOpen] = useState(false);
  
  // Use either the props or local state for dropdown
  const dropdownOpen = isDropdownOpen !== undefined ? isDropdownOpen : localIsDropdownOpen;
  const toggleDropdown = setIsDropdownOpen || setLocalIsDropdownOpen;
  
  // Background parallax effect
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!pageContainerRef.current) return;
      
      const { clientX, clientY } = e;
      const { width, height } = pageContainerRef.current.getBoundingClientRect();
      
      // Calculate mouse position as percentage of container
      const x = (clientX / width) * 100;
      const y = (clientY / height) * 100;
      
      setMousePosition({ x, y });
    };
    
    window.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleStoryTypeChange = (e) => {
    setFormData(prev => ({ ...prev, storyType: e.target.value }));
  };

  const handleRadioChange = (e) => {
    setFormData(prev => ({ ...prev, isAnonymous: e.target.value === 'anonymous' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsSubmitting(true);
      
      // Determine the API URL based on environment
      const apiUrl = process.env.NODE_ENV === 'production' 
        ? '/api/story?operation=create' // Production URL with operation parameter
        : 'http://localhost:3001/api/story?operation=create'; // Development URL with operation parameter
      
      // Send story data to the backend API
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          story: formData.story,
          isAnonymous: formData.isAnonymous,
          storyType: formData.storyType,
          language
        }),
      });
      
      const result = await response.json();
      
      if (!response.ok) {
        throw new Error(result.error || 'Failed to submit story');
      }
      
      // Use the returned data from the API
      const submittedStory = result.data[0];
      setSubmittedStory(submittedStory);
      setShowThankYouPopup(true);
    } catch (error) {
      alert(`Error submitting story: ${error.message || error}`);
    }
  };
  
  const generateStoryImage = () => {
    if (!storyCardRef.current) return null;
    
    return new Promise((resolve, reject) => {
      try {
        // Create a temporary clone of the story card for image generation
        const tempCard = document.createElement('div');
        tempCard.style.position = 'absolute';
        tempCard.style.left = '-9999px';
        tempCard.style.width = '550px';
        tempCard.style.backgroundImage = `url(${pBgImage})`;
        tempCard.style.backgroundRepeat = 'no-repeat';
        tempCard.style.backgroundPosition = 'center center';
        tempCard.style.backgroundSize = 'cover';
        tempCard.style.padding = '2rem';
        tempCard.style.borderRadius = '15px';
        tempCard.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.3)';
        tempCard.style.zIndex = '-1';
        document.body.appendChild(tempCard);
        
        // Create title container
        const titleContainer = document.createElement('div');
        titleContainer.style.display = 'flex';
        titleContainer.style.justifyContent = 'space-between';
        titleContainer.style.alignItems = 'center';
        titleContainer.style.marginBottom = '1.5rem';
        tempCard.appendChild(titleContainer);
        
        // Create title
        const title = document.createElement('h3');
        title.textContent = 'This Is My Story';
        title.style.color = 'white';
        title.style.fontSize = '1.8rem';
        title.style.fontWeight = 'bold';
        title.style.margin = '0';
        titleContainer.appendChild(title);
        
        // Create logo
        const logoImg = new Image();
        logoImg.src = logo;
        logoImg.style.height = '40px';
        logoImg.style.width = 'auto';
        titleContainer.appendChild(logoImg);
        
        // Create story text container
        const storyTextElement = document.createElement('p');
        storyTextElement.textContent = submittedStory.story;
        storyTextElement.style.color = 'white';
        storyTextElement.style.fontSize = '1.1rem';
        storyTextElement.style.lineHeight = '1.6';
        storyTextElement.style.whiteSpace = 'pre-wrap';
        storyTextElement.style.margin = '0';
        tempCard.appendChild(storyTextElement);
        
        // Wait for images to load
        logoImg.onload = () => {
          // Use html2canvas on the temporary card
          html2canvas(tempCard, {
            backgroundColor: null,
            useCORS: true,
            scale: 2, // Higher quality
            logging: false,
            width: 550,
            height: tempCard.offsetHeight
          }).then(canvas => {
            // Get image data and resolve promise
            const imageUrl = canvas.toDataURL('image/png');
            
            // Clean up - remove the temporary card
            document.body.removeChild(tempCard);
            
            resolve(imageUrl);
          }).catch(err => {
            // Clean up on error
            if (document.body.contains(tempCard)) {
              document.body.removeChild(tempCard);
            }
            console.error('Error generating image:', err);
            reject(err);
          });
        };
        
        // Handle logo load error
        logoImg.onerror = () => {
          // Still try to generate without waiting for logo
          html2canvas(tempCard, {
            backgroundColor: null,
            useCORS: true,
            scale: 2,
            logging: false,
            width: 550,
            height: tempCard.offsetHeight
          }).then(canvas => {
            const imageUrl = canvas.toDataURL('image/png');
            if (document.body.contains(tempCard)) {
              document.body.removeChild(tempCard);
            }
            resolve(imageUrl);
          }).catch(err => {
            if (document.body.contains(tempCard)) {
              document.body.removeChild(tempCard);
            }
            console.error('Error generating image:', err);
            reject(err);
          });
        };
      } catch (error) {
        console.error('Error setting up image generation:', error);
        reject(error);
      }
    });
  };
  
  const uploadImageToS3 = async (imageDataUrl, storyId) => {
    try {
      setIsUploading(true);
      
      // Convert base64 to blob
      const blob = await (await fetch(imageDataUrl)).blob();
      
      // Create form data for the server request
      const formData = new FormData();
      formData.append('image', blob, 'story-image.png');
      formData.append('storyId', storyId);
      
      // Determine the API URL based on environment
      const apiUrl = process.env.NODE_ENV === 'production' 
        ? '/api/upload' // Production URL (relative to the domain)
        : 'http://localhost:3001/api/upload'; // Development URL
      
      // Send to our serverless function
      const response = await fetch(apiUrl, {
        method: 'POST',
        body: formData,
      });
      
      if (!response.ok) {
        throw new Error('Failed to upload image to server');
      }
      
      const result = await response.json();
      
      if (!result.success) {
        throw new Error(result.error || 'Unknown error during upload');
      }
      
      setUploadedImageUrl(result.imageUrl);
      setIsUploading(false);
      return result.imageUrl;
    } catch (error) {
      setIsUploading(false);
      throw error;
    }
  };
  
  const downloadStoryImage = async () => {
    try {
      const imageUrl = await generateStoryImage();
      if (imageUrl) {
        const link = document.createElement('a');
        link.href = imageUrl;
        link.download = 'my-story.png';
        link.click();
      }
    } catch (error) {
      alert('There was an error generating your story image. Please try again.');
    }
  };
  
  const handleShare = async (platform) => {
    try {
      // Generate the image first
      const imageUrl = await generateStoryImage();
      
      if (!imageUrl) {
        throw new Error('Failed to generate story image');
      }
      
      // Upload to S3 if we don't already have a URL
      const s3Url = uploadedImageUrl || await uploadImageToS3(imageUrl, submittedStory.id);
      
      // Create the sharing text
      const shareText = `Check out my story: ${formData.story.substring(0, 100)}${formData.story.length > 100 ? '...' : ''}`;
      
      // Check if device is mobile
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      
      switch(platform) {
        case 'facebook':
          if (isMobile) {
            if (isIOS) {
              // iOS uses different URL schemes
              window.location.href = `fb://share?link=${encodeURIComponent(s3Url)}`;
              
              // Set a timeout to redirect to web version if app doesn't open
              setTimeout(() => {
                window.location.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(s3Url)}&quote=${encodeURIComponent(shareText)}`;
              }, 2000);
            } else {
              // Android
              window.location.href = `intent://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(s3Url)}&quote=${encodeURIComponent(shareText)}#Intent;package=com.facebook.katana;scheme=https;end`;
            }
          } else {
            // Desktop
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(s3Url)}&quote=${encodeURIComponent(shareText)}`, '_blank');
          }
          break;
          
        case 'instagram':
          // Instagram doesn't have a direct share URL
          // We'll download the image and prompt the user to share it manually
          downloadStoryImage();
          alert('Your story image has been downloaded. Please upload it manually to Instagram.');
          return;
          
        case 'linkedin':
          if (isMobile) {
            if (isIOS) {
              window.location.href = `linkedin://shareArticle?mini=true&url=${encodeURIComponent(s3Url)}&title=${encodeURIComponent('My Story')}&summary=${encodeURIComponent(shareText)}`;
              
              // Set a timeout to redirect to web version if app doesn't open
              setTimeout(() => {
                window.location.href = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(s3Url)}&title=${encodeURIComponent('My Story')}&summary=${encodeURIComponent(shareText)}`;
              }, 2000);
            } else {
              // Android
              window.location.href = `intent://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(s3Url)}&title=${encodeURIComponent('My Story')}&summary=${encodeURIComponent(shareText)}#Intent;package=com.linkedin.android;scheme=https;end`;
            }
          } else {
            // Desktop
            window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(s3Url)}&title=${encodeURIComponent('My Story')}&summary=${encodeURIComponent(shareText)}`, '_blank');
          }
          break;
          
        case 'whatsapp':
          if (isMobile) {
            // Direct to WhatsApp app
            window.location.href = `whatsapp://send?text=${encodeURIComponent(shareText + ' ' + s3Url)}`;
            
            // Set a timeout to redirect to web version if app doesn't open
            setTimeout(() => {
              if (isIOS) {
                window.location.href = `https://api.whatsapp.com/send?text=${encodeURIComponent(shareText + ' ' + s3Url)}`;
              } else {
                window.location.href = `intent://send?text=${encodeURIComponent(shareText + ' ' + s3Url)}#Intent;package=com.whatsapp;scheme=whatsapp;end`;
              }
            }, 2000);
          } else {
            // Desktop
            window.open(`https://web.whatsapp.com/send?text=${encodeURIComponent(shareText + ' ' + s3Url)}`, '_blank');
          }
          break;
          
        default:
          break;
      }
    } catch (error) {
      alert('There was an error sharing your story. Please try again.');
      console.error('Share error:', error);
    }
  };

  return (
    <PageContainer ref={pageContainerRef}>
      <LanguageSelectorContainer>
        <ButtonsContainer>
          <Link to="/stories">
            <MoreStoriesButton>
              {t.moreStories}
            </MoreStoriesButton>
          </Link>
          <LanguageSelector>
            <DropdownButton onClick={() => toggleDropdown(!dropdownOpen)}>
            {t.selectLanguage} ▼
            </DropdownButton>
            {dropdownOpen && (
              <DropdownContent>
                <DropdownItem onClick={() => { 
                  if (setLanguage) setLanguage('en');
                  toggleDropdown(false);
                }}>
                  {defaultTranslations.en.english}
                </DropdownItem>
                <DropdownItem onClick={() => {
                  if (setLanguage) setLanguage('si');
                  toggleDropdown(false);
                }}>
                  {defaultTranslations.si.sinhala}
                </DropdownItem>
                <DropdownItem onClick={() => {
                  if (setLanguage) setLanguage('ta');
                  toggleDropdown(false);
                }}>
                  {defaultTranslations.ta.tamil}
                </DropdownItem>
              </DropdownContent>
            )}
          </LanguageSelector>
        </ButtonsContainer>
      </LanguageSelectorContainer>

      <FormWrapper>
        <LogoContainer>
          <LogoContent>
            <Link to="/">
              <Logo src={logo} alt="CloseUp" />
            </Link>
            <Free2Love src={free2love} alt="Free to love" />
          </LogoContent>
        </LogoContainer>
        
        <FormContent>
          <Title>{t.title}</Title>
          <Subtitle>{t.subtitle}</Subtitle>

          <Form onSubmit={handleSubmit}>
            <Input
              type="text"
              name="name"
              placeholder={t.name}
              value={formData.name}
              onChange={handleChange}
              required
            />
            <Input
              type="email"
              name="email"
              placeholder={t.email}
              value={formData.email}
              onChange={handleChange}
              required
            />
            <Input
              type="tel"
              name="phone"
              placeholder={t.phone}
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <TextArea
              name="story"
              placeholder={t.story}
              value={formData.story}
              onChange={handleChange}
              required
              maxLength={500}
            />
            <CharacterCounter>
              {formData.story.length}/500
            </CharacterCounter>

            <PublishOptions>
              <PublishLabel>
                <RadioInput
                  type="radio"
                  name="publishOption"
                  value="named"
                  checked={!formData.isAnonymous}
                  onChange={handleRadioChange}
                />
                {t.publishWithName}
              </PublishLabel>
              <PublishLabel>
                <RadioInput
                  type="radio"
                  name="publishOption"
                  value="anonymous"
                  checked={formData.isAnonymous}
                  onChange={handleRadioChange}
                />
                {t.publishAnonymously}
              </PublishLabel>
            </PublishOptions>

            <div>
              <StoryTypeLabel>{t.storyType}</StoryTypeLabel>
              <StoryTypeOptions>
                <PublishLabel>
                  <RadioInput
                    type="radio"
                    name="storyType"
                    value="love"
                    checked={formData.storyType === 'love'}
                    onChange={handleStoryTypeChange}
                  />
                  {t.loveStory}
                </PublishLabel>
                <PublishLabel>
                  <RadioInput
                    type="radio"
                    name="storyType"
                    value="boot"
                    checked={formData.storyType === 'boot'}
                    onChange={handleStoryTypeChange}
                  />
                  {t.bootStory}
                </PublishLabel>
              </StoryTypeOptions>
            </div>

            <TermsText>
              By submitting, you agree that you have read and accept our <TermsLink onClick={() => setShowTerms(true)}>Terms and Conditions</TermsLink>
            </TermsText>

            <SubmitButton type="submit">{t.submit}</SubmitButton>
          </Form>
        </FormContent>
      </FormWrapper>

      <BackgroundEffect style={{
        transform: `translate(${(mousePosition.x - 50) / 20}px, ${(mousePosition.y - 50) / 20}px)`
      }} />
      
      {showThankYouPopup && submittedStory && (
        <ThankYouPopup>
          <PopupContent>
            <PopupCloseButton onClick={() => {
              setShowThankYouPopup(false);
              window.location.href = '/stories';
            }}>
              &times;
            </PopupCloseButton>
            
            <ThankYouTitle>Thank You For Submitting</ThankYouTitle>
            
            <StoryCard ref={storyCardRef}>
              <StoryTitleContainer>
                <StoryTitle>This Is My Story</StoryTitle>
                <StoryCardLogo src={logo} alt="CloseUp" />
              </StoryTitleContainer>
              <StoryText>{submittedStory.story}</StoryText>
            </StoryCard>
            
            <ShareSection>
              <ShareTitle>Share On</ShareTitle>
              {isUploading ? (
                <LoadingMessage>Preparing image for sharing...</LoadingMessage>
              ) : (
                <SocialIcons>
                  <SocialIcon onClick={() => handleShare('facebook')}>
                    <FaFacebook size={32} />
                  </SocialIcon>
                  <SocialIcon onClick={() => handleShare('whatsapp')}>
                    <FaWhatsapp size={32} />
                  </SocialIcon>
                </SocialIcons>
              )}
              <DownloadButton onClick={downloadStoryImage}>
                Download Story Image
              </DownloadButton>
            </ShareSection>
          </PopupContent>
        </ThankYouPopup>
      )}
      
      {/* Terms and Conditions Modal */}
      <TermsAndConditions 
        show={showTerms} 
        handleClose={() => setShowTerms(false)} 
      />
      
      {/* Cookie Consent Banner */}
      <CookieConsent />
    </PageContainer>
  );
};

const PageContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 100vh;
  background: url(${bgImage}) no-repeat center center;
  background-size: cover;
  position: relative;
  overflow: hidden;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    background: url(${pBgImage}) no-repeat center center;
    background-size: cover;
  }
`;

const BackgroundEffect = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${bgImage}) no-repeat center center;
  background-size: cover;
  z-index: -1;
  transition: transform 0.1s ease-out;
  opacity: 0.7;
  pointer-events: none;
  
  @media (max-width: 768px) {
    background: url(${pBgImage}) no-repeat center center;
    background-size: cover;
  }
`;

const LanguageSelectorContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 30px;
  z-index: 100;
  
  @media (max-width: 768px) {
    position: relative;
    top: 0;
    right: 0;
    width: 100%;
    padding: 15px;
    background-color: rgba(228, 25, 78, 0.9);
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 15px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;

const MoreStoriesButton = styled.button`
  background: none;
  border: 2px solid white;
  color: white;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  transition: all 0.3s;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
  
  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    padding: 0.8rem 1rem;
    font-size: 1rem;
  }
`;

const LanguageSelector = styled.div`
  position: relative;
  z-index: 20;
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const DropdownButton = styled.button`
  background: none;
  border: 2px solid white;
  color: white;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  transition: all 0.3s;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
  
  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    padding: 0.8rem 1rem;
    font-size: 1rem;
  }
`;

const DropdownContent = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-top: 0.5rem;
  min-width: 150px;
  z-index: 30;
  
  @media (max-width: 768px) {
    width: 100%;
    right: auto;
    left: 0;
  }
`;

const DropdownItem = styled.button`
  width: 100%;
  padding: 0.8rem 1rem;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  transition: background 0.3s;
  color: #e31837;

  &:hover {
    background: rgba(227, 24, 55, 0.1);
  }

  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  
  @media (max-width: 768px) {
    text-align: center;
    padding: 1rem;
  }
`;

const StoryTypeOptions = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 0.1rem;
  
  @media (max-width: 768px) {
    display: inline-flex;
    flex-wrap: wrap;
  }
`;

const SubmitButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  padding: 1rem;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s;
  width: 50%;
  align-self: center;

  &:hover {
    background-color: rgba(255, 255, 255, 0.9);
    color: #e4194e;
  }
  
  @media (max-width: 768px) {
    width: 80%;
    margin-top: 1rem;
    position: relative;
    bottom: 0;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;
  width: 100%;
`;

const LogoContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
`;

const Logo = styled.img`
  width: 120px;
  height: auto;
`;

const Free2Love = styled.img`
  width: 110px;
  height: auto;
`;

const FormContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Title = styled.h1`
  color: white;
  text-align: center;
  margin-bottom: 0.5rem;
  font-size: 2.2rem;
  font-weight: bold;
`;

const Subtitle = styled.p`
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  margin-bottom: 1.5rem;
  font-size: 1.1rem;
`;

const Input = styled.input`
  padding: 1rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  transition: all 0.3s;

  &::placeholder {
    color: rgba(255, 255, 255, 0.8);
  }

  &:focus {
    outline: none;
    background: rgba(255, 255, 255, 0.3);
  }
`;

const PublishLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  color: white;
  font-size: 0.9rem;
`;

const RadioInput = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: red;
`;

const TextArea = styled.textarea`
  padding: 1rem;
  border: none;
  border-radius: 8px;
  min-height: 100px;
  font-size: 1rem;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  resize: vertical;
  transition: all 0.3s;

  &::placeholder {
    color: rgba(255, 255, 255, 0.8);
  }

  &:focus {
    outline: none;
    background: rgba(255, 255, 255, 0.3);
  }
`;

const StoryTypeLabel = styled.label`
  display: flex;
  color: white;
  font-size: 1rem;
  margin-bottom: 0.8rem;
  font-weight: bold;
  padding-top:10px;
`;

const ThankYouPopup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const PopupContent = styled.div`
  background-color: #e4194e;

  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 20px;
  padding: 2rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PopupCloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
  z-index: 10;
`;

const ThankYouTitle = styled.h2`
  color: white;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 2rem;
  font-weight: bold;
`;

const StoryCard = styled.div`
  background: url(${pBgImage}) no-repeat center center;
  background-size: cover;
  border-radius: 15px;
  padding: 2rem;
  width: 100%;
  max-width: 550px;
  height: auto;
  min-height: 300px;
  max-height: 550px;
  margin: 0 auto 2rem auto;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const StoryTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

const StoryTitle = styled.h3`
  color: white;
  font-size: 1.8rem;
  text-align: left;
  font-weight: bold;
  margin: 0;
`;

const StoryCardLogo = styled.img`
  height: 40px;
  width: auto;
`;

const StoryText = styled.p`
  color: white;
  font-size: 1.1rem;
  line-height: 1.6;
  white-space: pre-wrap;
  overflow-y: auto;
  flex: 1;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 25;
  -webkit-box-orient: vertical;
`;

const ShareSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const ShareTitle = styled.h3`
  color: white;
  font-size: 2rem;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const SocialIcons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-bottom: 2rem;
`;

const SocialIcon = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  transition: transform 0.2s;
  
  &:hover {
    transform: scale(1.2);
  }
`;

const DownloadButton = styled.button`
  background-color: white;
  color: #e4194e;
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.9);
    transform: translateY(-2px);
  }
`;

const LoadingMessage = styled.p`
  color: white;
  font-size: 1.2rem;
  text-align: center;
  margin-bottom: 2rem;
`;

const TermsText = styled.span`
  color: white;
  font-size: 0.9rem;
  padding-top:10px;
`;

const TermsLink = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 0.9rem;
  text-decoration: underline;
`;

const TermsPopup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const TermsContent = styled.div`
  background-color: #e4194e;

  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 20px;
  padding: 2rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TermsCloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
  z-index: 10;
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
  background-color: #e4194e;
  border-radius: 20px;
  margin: 4rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  
  @media (max-width: 768px) {
    margin: 1rem;
    padding: 1.5rem;
    padding-left: 2rem;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  
  @media (max-width: 768px) {
    padding-bottom: 2rem;
    overflow-y: visible;
  }
`;

const PublishOptions = styled.div`
  display: flex;
  gap: 2rem;
  margin-bottom: 0rem;
  margin-top: 0.2rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.8rem;
  }
`;

const CharacterCounter = styled.p`
  color: white;
  font-size: 0.9rem;
  text-align: right;
  margin-top: -0.5rem;
`;

export default StoryForm;
